var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandwiches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 51,
    viewBox: "0 0 69 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_1337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.19 25.15C22.19 25.15 22.22 25.18 22.26 25.25C22.91 26.17 27.8 32.95 32.61 36.97H32.63C34.7 38.71 36.75 39.93 38.45 39.93C40.15 39.93 42.09 38.72 43.99 36.97C44.02 36.95 44.03 36.92 44.05 36.9H44.07C48.27 33.06 52.26 26.73 53.07 25.4H53.09C53.18 25.24 53.24 25.15 53.24 25.15",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.24C1.5 11.61 6.33 6.34 13.32 6.34C14.48 6.34 15.58 6.48 16.6 6.76C20.1 7.7 23.7 6.42 26.58 4.05C28.55 2.42 31.09 1.5 34.01 1.5C36.93 1.5 39.47 2.42 41.44 4.05C44.31 6.42 47.92 7.7 51.42 6.76C52.45 6.49 53.55 6.34 54.7 6.34C61.69 6.34 66.52 11.61 66.52 19.24",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63 36.97H1.5C1.5 39.07 1.63 41.09 1.78 42.82C2.06 45.76 4.46 48.02 7.4 48.15C13.3 48.4 23.64 48.79 34.02 48.79C44.4 48.79 54.74 48.4 60.64 48.15C63.58 48.02 65.97 45.76 66.25 42.82C66.4 41.09 66.53 39.07 66.53 36.97H43.99",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.05 36.9H44.06C54.39 36.78 62.71 36.53 62.71 36.53C62.71 36.53 63.57 33.93 63.57 31.06C63.57 28.19 62.23 25.68 62.23 25.68C62.23 25.68 58.58 25.53 53.08 25.4H53.06C47.86 25.28 41 25.15 34.01 25.15C29.96 25.15 25.94 25.2 22.26 25.25C12.92 25.4 5.80001 25.68 5.80001 25.68C5.80001 25.68 4.46001 28.19 4.46001 31.06C4.46001 33.93 5.32001 36.53 5.32001 36.53C5.32001 36.53 18.74 36.94 32.62 36.97H32.63",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.53 19.24C66.53 22.11 65.58 24.71 65.58 24.71C65.58 24.71 49.81 25.15 34.01 25.15C18.21 25.15 2.44001 24.71 2.44001 24.71C2.44001 24.71 1.49001 22.11 1.49001 19.24",
    stroke: "#075E76",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_1337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.03,
    height: 50.3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandwiches);
export default __webpack_public_path__ + "static/media/sandwiches.7f3b4e8f5277a301c1ef1c5660ed286f.svg";
export { ForwardRef as ReactComponent };